import { GridColDef } from '@mui/x-data-grid';
import AppDataGrid from '@shared/components/DataGrid';
import { VisitRow } from '../../entity';
import { VisitListApplyFilter } from '@shared/entity';

type VisitsListTableProps = {
  rows: VisitRow[];
  columns: GridColDef<VisitRow>[];
  columnHeaderHeight?: number;
  hideFooter: boolean;
  visitListApplyFilter: VisitListApplyFilter;
  onHeaderRowClick?: (label: string) => void;
};

const VisitsListTable = ({
  rows,
  columns,
  columnHeaderHeight,
  hideFooter,
  visitListApplyFilter,
  onHeaderRowClick,
}: VisitsListTableProps) => (
  <AppDataGrid
    disableColumnMenu={
      visitListApplyFilter === 'dashBoardVisitOverView' || visitListApplyFilter === 'onlyOpenVisits'
    }
    rows={rows}
    columns={columns}
    columnHeaderHeight={columnHeaderHeight}
    hideFooter={hideFooter}
    getRowClassName={params => {
      if (params.row.isHeader) return 'header-row';
      if (params.row.isPlaceholder) return 'placeholder-row';
      return '';
    }}
    getRowHeight={params =>
      params.model.isHeader
        ? GRID_STYLES.headerHeight
        : params.model.isPlaceholder
          ? GRID_STYLES.placeholderHeight
          : GRID_STYLES.rowHeight
    }
    onRowClick={
      onHeaderRowClick
        ? params => {
            if (params.row.isHeader) {
              onHeaderRowClick(params.row.label);
            }
          }
        : undefined
    }
    sx={GRID_STYLES.headerRow}
  />
);

export default VisitsListTable;

const height = 26;
const GRID_STYLES = {
  headerRow: {
    '& .header-row': {
      cursor: 'pointer',
    },
    '& .header-row .MuiDataGrid-cell': {
      backgroundColor: '#fff200ba',
      lineHeight: height,
      display: 'flex',
      alignItems: 'center',
    },
    '& .placeholder-row .MuiDataGrid-cell': {
      backgroundColor: '#f5f5f5',
    },
  },
  headerHeight: height,
  placeholderHeight: 28,
  rowHeight: 40,
} as const;
